import { store } from '@/store/store';

//store actions
const updateAuthStatus = ({
  isRunning = false,
  hasFailed = false,
  message = '',
  authSource = 'tinybeans'
}) => {
  store.dispatch('updateAuthStatus', {isRunning, hasFailed, message, authSource});
};

export {
  updateAuthStatus
};

